import React from 'react';
import cn from 'classnames';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { useSize } from '../hooks/useSize';
import s from './Viewer.scss';
const Viewer = (props)=>{
    var _props_node_externalRenderers, _props_node_extensionConfig;
    const attrs = props.node.attrs;
    const { deviation } = attrs;
    const Renderer = (_props_node_externalRenderers = props.node.externalRenderers) === null || _props_node_externalRenderers === void 0 ? void 0 : _props_node_externalRenderers.inline;
    const config = (_props_node_extensionConfig = props.node.extensionConfig) === null || _props_node_extensionConfig === void 0 ? void 0 : _props_node_extensionConfig.deviationThumb;
    const { width, height } = useSize(props.node.externalRenderers.mediaService, attrs, config, props.node.containerWidth);
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s[`preset-${props.node.presetId}`], s['outer-span']),
        "data-da-type": "da-deviation-thumb",
        "data-deviation": JSON.stringify(deviation),
        "data-width": attrs.width,
        "data-height": attrs.height,
        "data-cropping": attrs.cropping,
        "data-link": attrs.link,
        "data-aspect": attrs.aspect
    }, /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "editorExtDeviationViewer",
        humanError: "Oops, this deviation could not be shown."
    }, /*#__PURE__*/ React.createElement(Renderer, {
        deviation: attrs.deviation,
        width: width,
        height: height,
        crop: attrs.cropping,
        link: attrs.link,
        extOptions: config
    })));
};
export default Viewer;

//# sourceMappingURL=Viewer.js.map